<template>
  <div :class="divWidthChange" class="conteudoWidth fccPublicacoes">
    <fccTitlePage titlePage="Descrição Padrão das Vagas"></fccTitlePage>
    <div class="row mt-3">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsSolicitacoes"
          :orderby="sortBy"
          :optionsButton="optionVagas"
          :actions="actionsSolicitacoes"
          :items="lstSolicitacoes"
          responsive
          :porPage="itemPorPage"
          :titlePage="titlePage"
          :titlePDF="titlePage"
        ></fccTable>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsVagas"
          :items="lstControleVagas"
          responsive
          pagination
          :porPage="'15'"
          :titlePage="titlePage"
          :titlePDF="titlePage"
        ></fccTable>
      </div>
    </div>
    <fcc-modal
      centered
      id-modal="visualizaPadrao"
      title-modal="Cadastro das descrição"
      esconde-footer
      trava-esc
      size="xl"
      trava-back
    >
      <form
        @submit.prevent="vagasPadrao.idvagapadrao == 0 ? addCadastro() : editCadastro()"
        autocomplete="off"
      >
        <div class="my-2">
          <div class="row my-2">
            <div class="col-sm-1">
              <fccInput
                extraClasses="inputLabel text-center"
                type="number"
                v-model="vagasPadrao.ordem"
                required
                >Ordem</fccInput
              >
            </div>
            <div class="col-sm-2">
              <fccInput
                extraClasses="inputLabel text-center"
                type="number"
                required
                v-model="vagasPadrao.idcampo"
                >ID_Campo</fccInput
              >
            </div>
            <div class="col-sm-2">
              <fccInput
                extraClasses="inputLabel text-center"
                type="number"
                required
                v-model="vagasPadrao.valor"
                >Valor</fccInput
              >
            </div>
            <div class="col-sm-7">
              <fccInput extraClasses="inputLabel" required v-model="vagasPadrao.descricao"
                >Descrição</fccInput
              >
            </div>
          </div>
          <div class="row my-4">
            <div class="col-sm-12 text-right">
              <fccButton tipo="submit">{{ labelsSystem.salvar }}</fccButton>
            </div>
          </div>
        </div>
      </form>
    </fcc-modal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
import '../assets/sass/fccPublicacoes.scss'

export default {
  data() {
    return {
      titlePage: 'Publicações',
      baseUrlPublicacao: '',
      sortBy: 'nome',
      itemPorPage: '1000',
      alterado: false,
      vagasPadrao: {},
      lstControleVagas: [],
      actionsSolicitacoes: [
        {
          button: true,
          funcaoButton: 'deleteSolicitacao',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      optionVagas: [
        {
          button: true,
          funcaoButton: 'addField',
          icon: 'plus',
          tooltip: 'Adicionar',
          text: 'Adicionar',
          objpermCodigo: store.state.permissaoMenu.adicionar
        },
        {
          button: true,
          funcaoButton: 'editCadastro',
          icon: 'save',
          tooltip: 'Salvar',
          variant: 'primary',
          text: 'Salvar',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      lstSolicitacoes: [],

      fieldsSolicitacoes: [
        { key: 'idvagapadrao', label: 'ID.', sortable: true, tdClass: 'tdCadastro50' },
        { key: 'ordem', label: 'Ordem', tdClass: 'tdCadastro50' },
        { key: 'idcampo', label: 'ID Campo', sortable: true, tdClass: 'tdCadastro50' },
        { key: 'valor', label: 'Valor', tdClass: 'tdCadastro' },
        { key: 'descricao', label: 'Descrição', sortable: true, type: 'input' },
        { key: 'actions', label: '', tdClass: 'tdCadastro50' }
      ],
      fieldsVagas: [
        {
          key: 'tecnico',
          label: 'Técnico',
          sortable: true
        },
        {
          key: 'data',
          label: 'Data',
          sortable: true
        }
      ]
    }
  },
  methods: {
    addField() {
      this.vagasPadrao = {}
      this.vagasPadrao.idvagapadrao = 0
      this.vagasPadrao.idcontrolepadrao = 0
      this.vagasPadrao.ordem = this.ordem
      this.$root.$emit('bv::show::modal', 'visualizaPadrao')
    },
    lstVagasReservadas() {
      axios
        .get(
          this.baseUrlPublicacao + 'Publicacao/UsuariosCadastroReservasPadrao',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstControleVagas = response.data
        })
        .catch(this.setErrorSystem)
    },
    visualizaSolicitacao(_, item) {
      this.$root.$emit('bv::show::modal', 'visualizaPadrao')
      this.vagasPadrao = { ...item }
    },
    deleteSolicitacao(_, item) {
      this.callConfirm('Deseja realmente excluir a descrição padrão?', item.descricao).then(
        (result) => {
          if (result.value) {
            axios
              .delete(
                this.baseUrlPublicacao +
                  'Publicacao/ExcluirVagasReservadasPadrao?cdFuncionario=' +
                  this.dadosUserSession.usuCdFuncionario,
                { data: [item.idvagapadrao] },
                this.dadosLoginSession.fccTokenHeaders
              )
              .then(() => {
                this.callToast(this.mensagensUpdate.excluido, 'success')
                this.listarVagasReservadasPadrao()
              })
              .catch(this.setErrorSystem)
          }
        }
      )
    },
    editCadastro() {
      this.callConfirm('Deseja realmente salvar?', '').then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .put(
              this.baseUrlPublicacao +
                'Publicacao/AlterarVagasReservadaPadrao?cdFuncionario=' +
                this.dadosUserSession.usuCdFuncionario,
              this.lstSolicitacoes,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.$root.$emit('bv::hide::modal', 'visualizaPadrao')
              this.listarVagasReservadasPadrao()
              this.callToast(this.mensagensUpdate.editado, 'success')
            })
            .catch(this.setErrorSystem)
            .finally(this.carregaTexto)
        }
      })
    },
    addCadastro() {
      this.carregaTexto(this.codeMensagem('C03'))
      this.vagasPadrao.idcampo = parseInt(this.vagasPadrao.idcampo)
      this.vagasPadrao.ordem = parseInt(this.vagasPadrao.ordem)
      this.vagasPadrao.valor = parseInt(this.vagasPadrao.valor)
      axios
        .post(
          this.baseUrlPublicacao +
            'Publicacao/InserirVagasReservadaPadrao?cdFuncionario=' +
            this.dadosUserSession.usuCdFuncionario,
          [this.vagasPadrao],
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarVagasReservadasPadrao()
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.$root.$emit('bv::hide::modal', 'visualizaPadrao')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listarVagasReservadasPadrao() {
      axios
        .get(
          this.baseUrlPublicacao + 'Publicacao/ListarVagasReservadasPadrao',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstSolicitacoes = response.data
          if (this.lstSolicitacoes.length > 0) {
            this.ordem = this.lstSolicitacoes[this.lstSolicitacoes.length - 1].ordem + 1
          }
          this.lstVagasReservadas()
        })
        .catch(this.setErrorSystem)
    }
  },
  mounted() {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.listarVagasReservadasPadrao()
  }
}
</script>

